
export function getTimeDate(
    dateString: string | number,
    mode: 'full' | 'date' = 'full'
) {
    const date = new Date(dateString);

    const time =
        ("0" + date.getHours()).slice(-2) + ':' +
        ("0" + date.getMinutes()).slice(-2) + ':' +
        ("0" + date.getSeconds()).slice(-2);

    const day =
        ("0" + date.getDate()).slice(-2) + '.' +
        ("0" + (date.getMonth() + 1)).slice(-2) + '.' +
        date.getFullYear();

    if (mode === 'date') return day;
    return time + ' ' + day;
}




export function replaceEnterWithBr(text:string) {
    return text.replace(/\n/g, '<br/>');
}

export function replaceAndBoldText(text:string) {
    // Заменяем переносы строки на <br/>
    text = text.replace(/\n/g, '<br/>');
    // Заменяем *текст* на <b>текст</b>
    text = text.replace(/\*(.*?)\*/g, '<b>$1</b>');
    return text;
}


export function replaceBrWithEnter(text:string) {
    return text.replace(/<br\s*\/?>/g, '\n');
}

export function getRandomColor(name: string | undefined): string {
    const initial = name?.charAt(0).toUpperCase();
    const colors: string[] = [
        '#F44336', // red
        '#E91E63', // pink
        '#9C27B0', // purple
        '#673AB7', // deep purple
        '#3F51B5', // indigo
        '#2196F3', // blue
        '#03A9F4', // light blue
        '#00BCD4', // cyan
        '#009688', // teal
        '#4CAF50', // green
        '#8BC34A', // light green
        '#CDDC39', // lime
        '#FFEB3B', // yellow
        '#FFC107', // amber
        '#FF9800', // orange
        '#FF5722', // deep orange
        '#795548', // brown
        '#9E9E9E', // grey
        '#607D8B', // blue grey
    ];
    const index: number = initial ? initial.charCodeAt(0) % colors.length : 0;
    return colors[index];
}

interface OrderStatus {
    name: string;
    color: string;
    textColor: string;
}

export function getOrderStatus(num: number): OrderStatus {
    const orderStatuses: { [key: number]: OrderStatus } = {
        1: { name: 'ожидание средств', color: 'rgba(151, 151, 151, 0.13)', textColor: "#8b8b8b" },  // Orange
        2: { name: 'обрабатывается', color: 'rgba(255, 115, 13, 0.13)', textColor: "#ff730d" },  // Blue
        3: { name: 'оплачено', color: 'rgba(42, 185, 95, 0.13)', textColor: "#2ab95f" },  // Green
        4: { name: 'выполнено', color: 'rgba(39, 125, 255, 0.13)', textColor: "#277dff" },  // Green
        5: { name: 'отклонено', color: 'rgba(209, 0, 0, 0.13)', textColor: "#d10000" }  // Red
    };
    return orderStatuses[num] ? orderStatuses[num] : { name: 'error', color: '#808080', textColor: "#fffffff" };  // Default to 'error' with gray color
}

export function getTransactionStatus(type: string) {
    const transactionStatuses: { [key: string]: { name: string; color: string; textColor: string } } = {
        TRANSFER: {
            name: 'Перевод',
            color: 'rgba(39, 125, 255, 0.13)',
            textColor: '#277dff'
        },
        SALARY: {
            name: 'Зарплата',
            color: 'rgba(42, 185, 95, 0.13)',
            textColor: '#2ab95f'
        },
        EXPENSES: {
            name: 'Расходы',
            color: 'rgba(255, 115, 13, 0.13)',
            textColor: '#ff730d'
        }
    };

    return transactionStatuses[type]
        ? transactionStatuses[type]
        : { name: 'Неизвестно', color: '#808080', textColor: '#ffffff' };
}

export function getColorById(num: number): any {
    const orderStatuses: { [key: number]: any } = {
        1: { color: 'rgba(151, 151, 151, 0.13)', textColor: "#8b8b8b" },
        2: { color: 'rgba(255, 115, 13, 0.13)', textColor: "#ff730d" },
        3: { color: 'rgba(42, 185, 95, 0.13)', textColor: "#2ab95f" },
        4: { color: 'rgba(39, 125, 255, 0.13)', textColor: "#277dff" },
        5: { color: 'rgba(209, 0, 0, 0.13)', textColor: "#d10000" }
    };
    return orderStatuses[num] ? orderStatuses[num] : { name: 'error', color: '#808080', textColor: "#fffffff" };
}

const pad2 = (v: number) => String(v).padStart(2, "0");

export const dateStringFromTsUTC = (ts?: number | string | null) => {
    if (ts === undefined || ts === null || ts === "") return "";
    const d = new Date(Number(ts));
    return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
};

export const tsFromDateStringUTC = (dateStr?: string) => {
    if (!dateStr) return undefined;
    const [y, m, d] = dateStr.split("-").map(Number);
    if (!y || !m || !d) return undefined;
    return Date.UTC(y, m - 1, d);
};


